export const colors = ['default', 'member', 'sustainability', 'success', 'favourite'];
export const thicknesses = ['small', 'medium', 'large'];
//# sourceMappingURL=types.js.map